import { Component } from '@grafikr/components';
import Drawer from 'utils/components/drawer';

export default Component((node) => {
  const toggles = document.querySelectorAll(`[aria-controls="${node.id}"]`);
  const drawer = new Drawer(node);

  toggles.forEach(toggle => {
    toggle.addEventListener('click', drawer.toggle)
  })
});
